import { create } from "zustand";
import { IFutureSecurity } from "@/lib/interfaces and Enums/ENUMFutureSecurity";
import { ReferenceDataStatus } from "@/lib/interfaces and Enums/ENUMReferenceDataStatus";

// LQC-2493 - the futures contract universe a scratch-built block can reference, fetched
// only once a user picks Future in the ticket's instrument dropdown (see
// futureSecuritiesStoreACTIONS). Never on app load, and never for a user who only ever
// writes bond tickets.

type State = {
  futureSecurities: IFutureSecurity[];
  futureSecuritiesStatus: ReferenceDataStatus;
  futureSecuritiesError: string;
};

type Action = {
  // eslint-disable-next-line no-unused-vars
  setFutureSecurities: (futureSecurities: IFutureSecurity[]) => void;
  // eslint-disable-next-line no-unused-vars
  setFutureSecuritiesStatus: (status: ReferenceDataStatus) => void;
  // eslint-disable-next-line no-unused-vars
  setFutureSecuritiesError: (message: string) => void;
  clearFutureSecurities: () => void;
};

const futureSecuritiesStore = create<State & Action>((set) => ({
  futureSecurities: [],
  futureSecuritiesStatus: ReferenceDataStatus.Idle,
  futureSecuritiesError: "",

  // A successful load is the only way to Loaded - it also clears any prior error.
  setFutureSecurities: (futureSecurities) =>
    set({
      futureSecurities,
      futureSecuritiesStatus: ReferenceDataStatus.Loaded,
      futureSecuritiesError: "",
    }),
  setFutureSecuritiesStatus: (futureSecuritiesStatus) =>
    set({ futureSecuritiesStatus }),
  setFutureSecuritiesError: (futureSecuritiesError) =>
    set({
      futureSecuritiesError,
      futureSecuritiesStatus: ReferenceDataStatus.Error,
    }),
  clearFutureSecurities: () =>
    set({
      futureSecurities: [],
      futureSecuritiesStatus: ReferenceDataStatus.Idle,
      futureSecuritiesError: "",
    }),
}));

export default futureSecuritiesStore;
